export default __webpack_public_path__ + "static/media/debate_9.61acad50.JPG";